import(/* webpackMode: "eager" */ "/workspace/app/docs/page.tsx");
